import React from 'react';
import './Top5s.css';
import top5sArt from '../media/top5s_art.png';

const Top5s: React.FC = () => {
    // Using a Map structure to store different Top 5 categories
    const top5Categories = new Map([
        ['Top 5 DJs', {
            artists: [
                'DJ Jazzy Jeff',
                'DJ AM',
                'DJ Scratch',
                'Scratch Bastid',
                'Kid Capri'
            ],
            honoraryMention: 'Q-Bert & Mix Master Mike'
        }],
        ['Top 5 Producers', {
            artists: [
                'DJ Premier',
                'Teddy Riley',
                'The Neptunes/Pharrell',
                'Dr. Dre',
                'Timbaland'
                ,
            ],
            honoraryMention: 'Norman Whitfield'
        }],
        ['Top 5 Male Rappers', {
            artists: [
                'The Notorious B.I.G.',
                'Rakim',
                'Nas',
                'Jadakiss',
                'Eminem'
            ],
            honoraryMention: 'Jay-Z & Andre 3000'
        }],
        ['Top 5 Female Rappers', {
            artists: [
                'Queen Latifah',
                'Lil Kim',
                'MC Lyte',
                'Lauryn Hill',
                'Remy Ma'
            ],
            honoraryMention: 'Eve & Missy Elliott'
        }],
        ['Top 5 Male Vocalists', {
            artists: [
                'Marvin Gaye',
                'David Ruffin',
                'Luther Vandross',
                'Stevie Wonder',
                'Michael Jackson'
            ],
            honoraryMention: "George Michael"
        }],
        ['Top 5 Female Vocalists', {
            artists: [
                'Aretha Franklin',
                'Whitney Houston',
                'Amy Winehouse',
                'Sade',
                'Tina Marie'
            ],
            honoraryMention: 'Chaka Khan'
        }],
        ['Top 5 Hip Hop Albums', {
            artists: [
                'It Takes a Nation of Millions to Hold Us Back - Public Enemy',
                'Ready to Die - The Notorious B.I.G.',
                'Illmatic - Nas',
                '36 Chambers - Wu-Tang Clan',
                'DAMN - Kendrick Lamar'
            ],
            honoraryMention: 'Reasonable Doubt - Jay-Z'
        }],
        ['Top 5 Rap Groups', {
            artists: [
                'Public Enemy',
                'A Tribe Called Quest',
                'Wu-Tang Clan',
                'De La Soul',
                'Run-D.M.C.'
            ],
            honoraryMention: 'Gang Starr & N.W.A'
        }]
    ]);

    return (
        <div className="top5s page-container">
            <div className="page-image-column">
                <img src={top5sArt} alt="Top 5s" />
            </div>
            <div className="page-content-column">
                <h2>TOP FIVES</h2>
                <p className="top5s-footer">These are my top fives based on how these artists or the music impacted me</p>
                <div className="top5s-grid">
                    {Array.from(top5Categories.entries()).map(([category, data], index) => (
                        <div key={index} className="top5-card">
                            <h3>{category}</h3>
                            <ol className="top5-list">
                                {data.artists.map((artist, artistIndex) => (
                                    <li key={artistIndex}>{artist}</li>
                                ))}
                            </ol>
                            <div className="honorary-mention">
                                Honorary Mention: {data.honoraryMention}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Top5s;
